/** Trim and uppercase a leading "q": " q14372 " → "Q14372". */
export function normaliseQuote(raw: string | null | undefined): string {
  const s = (raw ?? '').trim();
  return s.replace(/^q/, 'Q');
}

/** A quote ending in -<digits> is a variation: Q17023-2. */
export function isVariation(quote: string): boolean {
  return /-\d+$/.test(quote);
}

/** Q17023-2 → Q17023. Non-variations come back unchanged. */
export function baseQuote(quote: string): string {
  return quote.replace(/-\d+$/, '');
}

export function quoteType(quote: string): 'Job' | 'Variation' {
  return isVariation(quote) ? 'Variation' : 'Job';
}

/** Natural compare so Q9 < Q10 and Q17011-2 < Q17011-10. */
export function compareQuotes(a: string, b: string): number {
  return a.localeCompare(b, undefined, { numeric: true });
}
